import type { ArticleRow } from '../../../shared/schemas/article';

export type ListPatternStatus = 'idle' | 'loading' | 'success' | 'empty' | 'error';

export interface ListPatternState {
  status: ListPatternStatus;
  items: ArticleRow[];
  errorMessage: string | null;
}

export const INITIAL_LIST_PATTERN_STATE: ListPatternState = {
  status: 'idle',
  items: [],
  errorMessage: null,
};

export function listPatternStateLoading(): ListPatternState {
  return { status: 'loading', items: [], errorMessage: null };
}

export function listPatternStateError(message: string): ListPatternState {
  return { status: 'error', items: [], errorMessage: message };
}

export function listPatternStateFromLoaded(items: ArticleRow[]): ListPatternState {
  if (items.length === 0) {
    return { status: 'empty', items: [], errorMessage: null };
  }
  return { status: 'success', items, errorMessage: null };
}
